module.exports = __webpack_public_path__ + "static/media/bannerImage2-l.74489970.jpg";